import type { Ability } from '@md/engine';
import { magnetFieldAbility } from './magnet-field.js';

/**
 * Pouvoirs de Magnetic Duo (spec §4 : `abilities/`).
 *
 * Un seul pouvoir en V1 — le champ magnétique — branché sur l'entrée `action`.
 * Attraction et répulsion n'en sont pas des pouvoirs séparés : ce sont des
 * CONSÉQUENCES de deux champs actifs, donc des règles d'interaction
 * (`interactions.ts`).
 */
export const ABILITIES: readonly Ability[] = [magnetFieldAbility];

export * from './magnet-field.js';
